import {
  MembershipOptionsV2,
  MembershipPricingOption,
  PricingOption
} from "@shared/graphql.types";
import { Typography } from "@shared/ui.primitives";

export const PricingOptionSaving: React.FC<{
  membershipOptions?: Array<MembershipOptionsV2>;
  prices?: Array<PricingOption>;
  selectedPrice?: PricingOption;
}> = ({ prices, selectedPrice, membershipOptions }) => {
  if (!membershipOptions || !prices || !selectedPrice) {
    return null;
  }
  if ((selectedPrice as MembershipPricingOption).membership) {
    if (
      (selectedPrice as MembershipPricingOption).membership?.sku?.startsWith(
        "BP_TRIAL"
      )
    ) {
      const membershipOption = membershipOptions.find(
        (option) =>
          option.sku ===
          (selectedPrice as MembershipPricingOption).membership.sku
      );
      if (!membershipOption) {
        return null;
      }
      return (
        <Typography variant="body-sm">
          You{" "}
          <Typography variant="body-sm-bold" as="span" colour="accent-dark">
            saved {membershipOption.saving}
          </Typography>{" "}
          from this product with a free trial
        </Typography>
      );
    }
    return null;
  }
  const saving = prices.find(
    (price) =>
      typeof (price as MembershipPricingOption).membership !== "undefined"
  )?.priceText;
  if (!saving) {
    return null;
  }
  return (
    <Typography variant="body-sm">
      Beauty Pie+ Members only pay{" "}
      <Typography variant="body-sm-bold" as="span" colour="accent-dark">
        {saving}
      </Typography>{" "}
      for this product
    </Typography>
  );
};
